import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=c17e703a&scoped=true&"
import script from "./policies.vue?vue&type=script&lang=js&"
export * from "./policies.vue?vue&type=script&lang=js&"
import style0 from "./policies.vue?vue&type=style&index=0&id=c17e703a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17e703a",
  null
  
)

export default component.exports